<template>
  <div class="queryindex">
    <div class="aqueryindex-info">
      <div class="aqueryindex-info-name" >
        <input type="text" class="item-ipt" placeholder="请输入客户名称" v-model="cusName">
        <button class="item-btn" @click="getCusVirAccountByLoginid">查询</button>
      </div>
      <div class="aqueryindex-info-text">
        温馨提示：本页面展示客户均为非不良客户，虚拟账户余额显示为客户当前可供系统扣款的金额。若客户承付日当天或之前已还款但未显示在虚拟账户余额中，请联系我司财务核实客户实际到账情况。
      </div>
    </div>
    <div class="aqueryindex-content">
      <template v-if="xiaodaiData.length>0">
        <div class="aqueryindex-content-item">
          <div class="item-title">国正科贷</div>
          <div class="item-info">
            <div class="info-name info-line">客户名称</div>
            <div class="info-account">虚拟账户余额(元)</div>
          </div>
          <div class="item-text" v-for="item in xiaodaiData" :key="item.cusId" @click="handleXDToDetail(item)">
            <div class="text-name text-line">{{item.cusName}}</div>
            <div class="text-account">{{item.advancesAmt|filerthousandchar}}</div>
          </div>
        </div>
      </template>
      <template v-if="zulinData.length>0">
        <div class="aqueryindex-content-item aqueryindex-content-zulin" >
          <div class="item-title">正奇租赁</div>
          <div class="item-info">
            <div class="info-name info-line">客户名称</div>
            <div class="info-account">虚拟账户余额(元)</div>
          </div>
          <div class="item-text" v-for="item in zulinData" :key="item.cusId" @click="handleZLToDetail(item)">
            <div class="text-name text-line">{{item.cusName}}</div>
            <div class="text-account">{{item.advancesAmt|filerthousandchar}}</div>
          </div>
        </div>
      </template>
    </div>

  </div>
</template>

<script type="text/ecmascript-6">
import { DetailItem, Field } from 'mand-mobile'
import { get } from '@/api/api'
import { addthousandchar } from '@/tools/common'
export default {
  name: 'QueryIndex',
  components: {
    [Field.name]: Field,
    [DetailItem.name]: DetailItem
  },
  data () {
    return {
      cusName: '',
      loginid: '',
      xiaodaiData: [],
      zulinData: []
    }
  },
  async beforeMount () {
    await this.getCusVirAccountByLoginid()
  },
  methods: {
    async getCusVirAccountByLoginid () {
      this.loginid = localStorage.getItem('loginid')
      const result1 = await get('/api/CBMS-APP/virAccount/queryCusVirAccountByLoginid', {
        loginId: this.loginid,
        comBrId: '100001',
        cusName: this.cusName
      })
      if (result1.success) {
        this.xiaodaiData = result1.data
      }
      const result2 = await get('/api/CBMS-APP/virAccount/queryCusVirAccountByLoginid', {
        loginId: this.loginid,
        comBrId: '400001',
        cusName: this.cusName
      })
      if (result2.success) {
        this.zulinData = result2.data
      }
    },
    handleXDToDetail (item) {
      this.$router.push({
        name: 'queryxd',
        params: {
          cusId: item.cusId,
          comBrId: item.comBrId,
          loginid: this.loginid
        }
      })
    },
    handleZLToDetail (item) {
      window.open('https://fr.zqfinancial.com:443/webroot/decision/view/report?viewlet=Mobile/ln_repayment/lease_repayment_mobile.cpt&op=h5&cus_id=' + item.cusId + '&com_br_id=' + item.comBrId)
    }
  },
  filters: {
    filerthousandchar (num) {
      return addthousandchar(num.toString())
    }
  }
}
</script>

<style scoped lang="css">
.queryindex{
  position : relative;
  width : 100vw;
  min-height : 100vh;
  padding-bottom : 64px;
  overflow-x : hidden;
  overflow-y : scroll;
}
.queryindex .aqueryindex-info{
  position: fixed;
  width: calc(100vw - 40px);
  padding: 20px;
  border-bottom: 1px solid #8b8787;
  background: #687591;
}
.queryindex .aqueryindex-info .aqueryindex-info-name{
  display : flex;
  align-items : center;
  padding : 16px;
  font-family: MyriadPro-Regular;
  font-size: 32px;
  font-weight: normal;
  font-stretch: normal;
  color: #333333;
}
.queryindex .aqueryindex-info .aqueryindex-info-text{
  text-indent : 32px;
  font-size : 28px;
  font-family: MyriadPro-Regular;
  font-weight: normal;
  font-stretch: normal;
}
.queryindex .aqueryindex-info .aqueryindex-info-name .item-ipt{
  flex : 1;
  height : 32px;
  padding : 16px 0 16px 16px;
  border-top: 1px solid #8b8787;
  border-bottom: 1px solid #8b8787;
  border-left: 1px solid #8b8787;
  border-right:none;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  outline : none;
  margin-left:16px;
}
.queryindex .aqueryindex-info .aqueryindex-info-name .item-btn {
  width : 140px;
  height : 64px;
  border-radius: 0;
}

.aqueryindex-content {
  margin-top: 300px;
}
.aqueryindex-content .aqueryindex-content-item{
  margin: 0 20px;
  border: 1px solid #8b8787;
  border-radius: 8px;
  margin-bottom: 16px;
}
.aqueryindex-content .aqueryindex-content-item .item-title {
  padding-top: 16px;
  padding-left: 16px;
  padding-bottom: 16px;
  font-family: MyriadPro-Regular;
  font-size: 36px;
  font-weight: normal;
  font-stretch: normal;
  color: #333333;
  border-bottom: 1px solid #8b8787;
}
.aqueryindex-content .aqueryindex-content-item .item-info {
  padding-top: 16px;
  padding-left: 16px;
  padding-bottom: 16px;
  display: flex;
  text-align: left;
  justify-content: center;
  font-size: 26px;
  font-weight: normal;
  font-stretch: normal;
  color: #333333;
  border-bottom: 1px solid #8b8787;
}
.aqueryindex-content .aqueryindex-content-item .item-info .info-name {
  margin-right: 16px;
  flex: 1;
}
.aqueryindex-content .aqueryindex-content-item .item-info .info-line {
  border-right: 1px solid #333333;
}
.aqueryindex-content .aqueryindex-content-item .item-info .info-account {
  width: 240px;
}

.aqueryindex-content .aqueryindex-content-item .item-text{
  padding-top: 38px;
  padding-left: 16px;
  padding-bottom: 38px;
  display: flex;
  text-align: left;
  justify-content: center;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  color: #8b8787;
  border-bottom: 1px solid #333333;

}
.aqueryindex-content .aqueryindex-content-item .item-text .text-name {
  margin-right: 16px;
  flex: 1;
}

.aqueryindex-content .aqueryindex-content-item .item-text .text-line {
  flex: 1;
  border-right: 1px solid #333333;
}
.aqueryindex-content .aqueryindex-content-item .item-text .text-account {
  width: 240px;
}
.aqueryindex-content .aqueryindex-content-zulin{
  margin-top: 32px;
}
</style>
